"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
const uom_1 = require("@genesys/uom");
function parse(velocities) {
    const units = velocities[0].map(v => uom_1.Serialize.stringToUnit(v.substring(1, v.length - 1)));
    const velocitiesList = [];
    let velocityList = [];
    for (const velocity of velocities.slice(2)) {
        if (velocity[0]) {
            velocityList.push(velocity);
        }
        else if (velocityList.length) {
            velocitiesList.push(velocityList);
            velocityList = [];
        }
    }
    if (velocityList.length) {
        velocitiesList.push(velocityList);
    }
    return {
        units: {
            airFlow: units[0],
            airInPressure: units[1],
            airInTemperature: units[2],
            airInHumidity: units[3],
            fluidTemperatureIn: units[4],
            fluidFlow: units[5],
            weightTotalPower: units[6],
            supplierTotalPower: units[7],
            weightSensiblePower: units[8],
            supplierSensiblePower: units[9],
            weightPressure: units[10],
            supplierPressure: units[11]
        },
        input: velocitiesList.map(l => l.map(v => {
            const parseAmount = createParseAmount(v, units);
            return {
                airFlow: parseAmount(0),
                airInPressure: parseAmount(1),
                airInTemperature: parseAmount(2),
                airInHumidity: parseAmount(3),
                fluidInTemperature: parseAmount(4),
                fluidFlow: parseAmount(5),
                weightTotalPower: parseAmount(6),
                supplierTotalPower: parseAmount(7),
                weightSensiblePower: parseAmount(8),
                supplierSensiblePower: parseAmount(9),
                weightPressure: parseAmount(10),
                supplierPressure: parseAmount(11)
            };
        }))
    };
}
function createParseAmount(row, units) {
    return (index) => {
        const unit = units[index];
        if (!unit) {
            throw new Error("Velocity: Unknown unit at column index: " + index);
        }
        const amount = row[index];
        if (!amount) {
            return "";
        }
        const value = parseFloat(amount);
        return uom_1.Serialize.amountToString(uom_1.Amount.create(value, unit));
    };
}
//# sourceMappingURL=parse-fluid-velocity.js.map